__turbopack_context__.v({
  "className": "-yN_Ua_className",
  "variable": "-yN_Ua_variable",
});
